import { VariableValueSimulator } from '@iotize/virtual-tap';

export class ConstantValueSimulator implements VariableValueSimulator {
  constructor(
    private readonly settings: {
      value: number;
    }
  ) {}

  generateNextValue(): number | number[] {
    return this.settings.value;
  }
}
